import React from "react";
import "./styles.scss";
import { FeatureItem } from "molecules";
import { isMobile } from "react-device-detect";

const getOddItems = elements => Array.from({length:elements.length},(v,k)=>k)
                                     .filter( item => item %2 !== 0)
                                     .map( position => elements[position]);

const getEvenItems = elements => Array.from({length:elements.length},(v,k)=>k)
                                      .filter( item => item %2 === 0)
                                      .map( position => elements[position]);
                                      
const generateItems = elements => elements.map( element => <FeatureItem key={element.title}
                                                                      icon={element.icon} 
                                                                      title={element.title} 
                                                                      description={element.description}/> );

export default props => {
  return <div className="asymetric-grid">
    { isMobile &&
      <div className="column">
        {generateItems(props.elements)}
      </div>
    }
    { !isMobile &&
      <div key="right" className="column">
        {generateItems(getEvenItems(props.elements))}
      </div>
    }
    { !isMobile &&
      <div key="left" className="column">
        {generateItems(getOddItems(props.elements))}
      </div>
    }
  </div>
};
